import { Component, OnInit } from "@angular/core";
import { NotificationsService } from "src/app/services/general/notifications/notifications.service";
import { FireBaseService } from "src/app/services/fireBase-service/fire-base.service";
import { userNotification } from "src/app/interfaces/notification.model";
import {Filter} from 'src/app/interfaces/filter.model';
import { PermissionsLables } from "src/app/enums/Permissions.enum";
import { finalize } from "rxjs";


@Component({
  selector: "topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.css"]
})

export class TopbarComponent implements OnInit {
  PermissionsLables=PermissionsLables
  pageSize = 10;
  page=1
  filter = new Filter();
  totalPages:number=1
  constructor(
     private notificationsService: NotificationsService,
      private fireBaseService : FireBaseService 
      ) 
      {
        this.getFilter()
         this.getUserNotifications();
       // this.listenOnNotificationsService();
      }
 

    userNotificationsList : userNotification [] = [];
    showBadge : boolean = false;
    BadgeNumber : number = 0;

  ngOnInit() {
    this.listenOnNotificationsService();
    this.getBadgeNumber()
    
  }
  getBadgeNumber(){
    this.notificationsService.Get('UnreadCount').pipe(finalize(()=>{

    })).subscribe(res =>{
      this.BadgeNumber=res.body.data
    })
  }
  getUserNotifications(): void {
    this.notificationsService.Get('Private',this.filter).subscribe(res => {
      res.body.data.map(val => val.orderId=JSON.parse(val.data)?.OrderId)
      let oldNotificationsList : userNotification [] = [];
      oldNotificationsList = this.userNotificationsList;
      this.userNotificationsList =[...this.userNotificationsList, ...res.body.data];
      this.totalPages=res.body.totalPages
      if(this.userNotificationsList > oldNotificationsList){
        this.showBadge = true;
     //   this.BadgeNumber = this.userNotificationsList.length - oldNotificationsList.length;
      }
    })
  }

  firstComponentFunction(){    
    this.fireBaseService.refreshNotificationsList();    
  }

  // get notitications when new notification has been recived
  listenOnNotificationsService() : any {
     if (this.fireBaseService.subsVar == undefined) {    
      this.fireBaseService.subsVar = this.fireBaseService.    
      invokeNotificationComponentFunction.subscribe(() => {    
        this.getUserNotifications();
        this.getBadgeNumber()
      });    
    }   
  }
  readNotification(id){
    this.notificationsService.ReadNotification(`Read/${id}`).subscribe(res =>{
      this.getUserNotifications()
      this.getBadgeNumber()
      this.userNotificationsList.map(val =>val.id==id?val.isRead=true:'')
    })
  }

  readAllNotification(id){
    this.notificationsService.delete(`clear`).subscribe(res =>{
      this.getUserNotifications()
      this.getBadgeNumber()
    
      this.userNotificationsList.map(val =>val.isRead=true)
    })
  }
  getNotification(e){
    console.log(this.page,this.totalPages)
    if(this.page<this.totalPages){
      console.log(this.page,this.totalPages)
      this.page++
      this.getFilter()
     this.getUserNotifications()
    }
 
  }
  getFilter(){
    this.filter.pageNumber = this.page ;
    this.filter.pageSize = this.pageSize;
    this.filter.prepareFilter();

  }
}
